<template>
  <v-sheet v-if="isMenu" class="bottom-navigation">
    <!-- <v-sheet width="20%" style="cursor: pointer; padding-top: 6px" @click="$router.replace('/').catch(() => {})">
      <img height="54" :src="require(`@/assets/menus/${getMenuIcon(0, $route.path == '/')}`)" />
    </v-sheet> -->

    <button type="button" :class="['bottom-navigation-item', { 'is-active': $route.path == '/' }]" aria-label="홈" @click="$router.push('/').catch(() => {})">
      <v-icon class="bottom-navigation-icon" size="25">
        {{ $route.path == "/" ? "mdi-home" : "mdi-home-outline" }}
      </v-icon>
    </button>

    <!-- <v-sheet width="25%" style="cursor: pointer; padding-top: 6px" @click="$router.push('/castle').catch(() => {})">
      <img height="54" :src="require(`@/assets/menus/${getMenuIcon(0, $route.path.startsWith('/castle'))}`)" />
    </v-sheet> -->

    <!-- <v-sheet width="25%" style="cursor: pointer; padding-top: 6px" @click="$router.push('/reservation/buy').catch(() => {})">
      <img height="54" :src="require(`@/assets/menus/${getMenuIcon(1, $route.path.startsWith('/reservation'))}`)" />
    </v-sheet> -->

    <button
      type="button"
      :class="['bottom-navigation-item', { 'is-active': $route.path.startsWith('/location') || $route.path.startsWith('/eventPage/STORE') }]"
      aria-label="오시는 길"
      @click="$router.push('/location').catch(() => {})"
    >
      <v-icon class="bottom-navigation-icon" size="25">
        {{ $route.path.startsWith("/location") || $route.path.startsWith("/eventPage/STORE") ? "mdi-map-marker" : "mdi-map-marker-outline" }}
      </v-icon>
    </button>

  </v-sheet>
</template>
<script>
import { isMenuPage } from "@/constant"
import { mapState, mapGetters } from "vuex"

export default {
  data: () => ({
    bottoms: [],
  }),

  computed: {
    ...mapState(["lang"]),

    isMenu() {
      return isMenuPage(this.$route.path)
    },
  },

  methods: {
    getMenuIcon(index, isActive) {
      let iconPath = this.getLangPath()

      switch (index) {
        // case 0:
        //   iconPath += isActive ? "main-active.png" : "main.png"
        //   break
        case 0:
          iconPath += isActive ? "guest-active.png" : "guest.png"
          break
        case 1:
          iconPath += isActive ? "reserve-active.png" : "reserve.png"
          break
        case 2:
          iconPath += isActive ? "map-active.png" : "map.png"
          break
        case 3:
          iconPath += isActive ? "mypage-active.png" : "mypage.png"
          break
        case 4:
          iconPath += isActive ? "home-active.png" : "home.png"
          break

        // case 3:
        //   iconPath += isActive ? "makeup-active.png" : "makeup.png"
        //   break

        default:
          break
      }
      return iconPath
    },

    getLangPath() {
      //const supportLang = ["ko", "en", "jp"]
      switch (this.lang) {
        case "ko":
          return ""
        case "jp":
          return "jp/"
        default:
          return "en/"
      }
    },
  },
}
</script>
<style scoped>
.bottom-navigation {
  position: fixed;
  left: 50%;
  bottom: calc(8px + env(safe-area-inset-bottom));
  z-index: 90;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: center;
  width: calc(100% - 28px);
  max-width: 548px;
  height: 46px;
  padding: 0;
  overflow: visible;
  background: transparent !important;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  transform: translateX(-50%);
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}
.bottom-navigation-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 46px;
  padding: 0;
  overflow: hidden;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.bottom-navigation-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  color: #6f686c !important;
  background: rgba(255, 255, 255, 0.66);
  border: 1px solid rgba(255, 255, 255, 0.88);
  border-radius: 50%;
  box-shadow: 0 2px 10px rgba(67, 47, 57, 0.1);
}
.bottom-navigation-item.is-active .bottom-navigation-icon {
  color: #d3487a !important;
  background: rgba(255, 255, 255, 0.78);
}
.bottom-navigation-item:active {
  background: rgba(255, 255, 255, 0.62);
  transform: scale(0.97);
}
.bottom-navigation-item:focus-visible {
  outline: 2px solid rgba(211, 72, 122, 0.48);
  outline-offset: -2px;
}
.bottom-navigation-item.is-active::after {
  position: absolute;
  bottom: -1px;
  left: 50%;
  width: 24px;
  height: 2px;
  background: #d3487a;
  border-radius: 999px;
  content: "";
  transform: translateX(-50%);
}
@media (max-width: 360px) {
  .bottom-navigation {
    width: calc(100% - 20px);
  }
}
@media (prefers-reduced-motion: reduce) {
  .bottom-navigation-item:active {
    transform: none;
  }
}
</style>
